// Product API
import ajax from './_ajax';

const api = {};
api.getCategoryGroups = function () {
  return ajax.get('/api/CategoryGroup/GetAll');
};
api.getCategoryFloors = function () {
  return ajax.get('/api/CategoryFloor/GetAll');
};
api.searchAllProducts = function (params) {
  return ajax.post('/api/Product/SearchAllProducts', params);
};

// WidhList API
api.wishlistSave = function (params) {
  return ajax.post('/api/Wishlist/Save', params);
};
api.wishlistDeleteByProductId = function (id) {
  return ajax.post('/api/Wishlist/DeleteByProductId?productId=' + id);
};

// 协议商品API
api.searchAgreementProducts = function (params) {
  return ajax.post('/api/Product/SearchAgreementProducts', params);
};
api.searchPurchaseAgreementProducts = function (params) {
  return ajax.post('/api/Product/SearchPurchaseAgreementProducts', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/productApi.js